/**
 * batch-11 (H2) — privacy hardening for the sandboxed HTML-email iframe.
 *
 * `sandbox=""` already blocks scripts/navigation/forms, but it does NOT stop
 * the browser from fetching remote `<img>`/CSS/fonts referenced by the email —
 * so opening an email silently fires tracking pixels and leaks the operator's
 * IP to the sender. Prepending a restrictive CSP `<meta>` to the srcDoc blocks
 * every remote fetch (only inline content + `data:` URIs render), which kills
 * read-receipts and the IP leak while still showing the message. Pair this with
 * `sandbox=""` and `referrerPolicy="no-referrer"` on the iframe.
 *
 * A leading `<meta http-equiv>` in srcDoc is hoisted into the document head by
 * the parser before any resource-loading element, so the policy applies to the
 * whole email regardless of whether it carries its own <html>/<head>.
 */
const EMAIL_CSP =
  "default-src 'none'; img-src data:; style-src 'unsafe-inline' data:; font-src data:; media-src data:";

export function hardenedEmailSrcDoc(html: string): string {
  return (
    `<meta http-equiv="Content-Security-Policy" content="${EMAIL_CSP}">` +
    `<meta name="referrer" content="no-referrer">${html}`
  );
}
